import { ProfileContext } from '@app/app/_context/ProfileContext/ProfileContext';
import { useContext } from 'react';

export function useProfile() {
    return useContext(ProfileContext);
}
